import React, {useEffect, useState} from "react"
import {Avatar, Button, Descriptions, message, Modal, Space, Spin, Tag} from "antd"
import {useDispatch, useSelector} from "react-redux"
import global from "../../global"

interface ShowOrdersInfoProps {
  orderNo: string
  onClose: () => void
  onRefundSuccess: () => void
}

/**
 * 定义ShowOrderInfoType
 * @constructor
 */
interface ShowOrderInfoType {
  showName: string;
  orderNo: string;
  orderType: string;
  price: number;
  name: string;
  mobile: string;
  province: string;
  seats: string[];
  created: string;
  amount: number;
  payStatus: string;
  orderStatus: string;
  remark: string;
}

const ShowOrdersInfo: React.FC<ShowOrdersInfoProps> = ({orderNo, onClose, onRefundSuccess}) => {
  const [loading, setLoading] = useState(false)
  const [refundLoading, setRefundLoading] = useState(false)
  
  const showOrders = useSelector((state: any) => state.showOrders)
  const dispatch = useDispatch()

  const [messageApi, contextMessageHolder] = message.useMessage()

  useEffect(() => {
    if (orderNo) {
      setLoading(true)
      dispatch.showOrders.getInfo(orderNo).then((res: any) => {
        setLoading(false)
        if (res.code !== 0) {
          messageApi.error(res.msg || "获取订单详情失败")
        }
      }).catch(() => {
        setLoading(false)
        messageApi.error("获取订单详情失败")
      })
    }
  }, [orderNo, dispatch.showOrders, messageApi])

  const handleRefund = () => {
    Modal.confirm({
      title: "确认退款",
      content: `确定要对订单 ${orderNo} 进行退款操作吗？`,
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        setRefundLoading(true)
        try {
          const res = await dispatch.showOrders.refund(orderNo)
          if (res.code === 0) {
            messageApi.success("退款成功")
            onRefundSuccess()
            onClose()
          } else {
            messageApi.error(res.msg || "退款失败")
          }
        } catch (error) {
          messageApi.error("退款失败")
        } finally {
          setRefundLoading(false)
        }
      }
    })
  }

  const info = showOrders.info as ShowOrderInfoType

  return (
    <>
      {contextMessageHolder}
      <div style={{padding: "20px 0"}}>
        <Spin spinning={loading}>
          <Descriptions 
            title="" 
            column={1} 
          >
            <Descriptions.Item label="订单号">{info?.orderNo}</Descriptions.Item>
            <Descriptions.Item label="演出名称">{info?.showName}</Descriptions.Item>
            <Descriptions.Item label="选手姓名">{info?.name}</Descriptions.Item>
            <Descriptions.Item label="手机号码">{info?.mobile}</Descriptions.Item>
            <Descriptions.Item label="参演省份">{info?.province}</Descriptions.Item>
            <Descriptions.Item label="订单总价">¥{info?.price/100}</Descriptions.Item>
            <Descriptions.Item label="实付金额">¥{info?.amount/100}</Descriptions.Item>
            <Descriptions.Item label="支付状态">
              <Tag color={global.getPayStatusColor(info?.payStatus || "")}>
                {global.getPayStatusText(info?.payStatus || "")}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="订单状态">
              <Tag color={global.getOrderStatusColor(info?.orderStatus || "")}>
                {global.getOrderStatusText(info?.orderStatus || "")}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="座位">{info?.seats?.join(",")}</Descriptions.Item>
            <Descriptions.Item label="下单时间">{info?.created}</Descriptions.Item>
            <Descriptions.Item label="备注">{info?.remark || "-"}</Descriptions.Item>
          </Descriptions>
        </Spin>

        <div style={{marginTop: "20px", textAlign: "center"}}>
          <Button 
            type="primary" 
            danger 
            onClick={handleRefund}
            loading={refundLoading}
            disabled={info?.payStatus !== "PAID"}
          >
            退款
          </Button>
        </div>
      </div>
    </>
  )
}

export default ShowOrdersInfo 